const formatCardNumber = (value) => {
  // 1. 移除所有非数字字符
  const cleanValue = value.replace(/\D/g, '');
  // 2. 每4位添加一个 '-'
  // (?=\d) 是前瞻断言，确保后面还有数字才加分隔符，避免末尾多出一个 '-'
  return cleanValue.replace(/(\d{4})(?=\d)/g, '$1-');
};

const minin = {
  data() {
    return {
      baseUrl: 'car',
      form: {},
      formCtrl: [
        {
          label: "车队长",
          keyName: "fleet",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
          // disabled: true,
        },
        {
          label: "车辆状态",
          keyName: "carstatus",
          type: "select",
          options: [
            { label: "在用", value: "在用" },
            { label: "停用", value: "停用" },
            { label: "报废", value: "报废" },
            { label: "已卖", value: "已卖" },
          ],
          className: "instyle",
        },
        {
          label: "车辆类型",
          keyName: "type",
          type: "select",
          options: [
            { label: "大车", value: "大车" },
            { label: "小车", value: "小车" },
          ],
          className: "instyle",
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          className: "instyle",
        },
        {
          label: "司机",
          keyName: "driver",
          err: "请选择司机",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        {
          label: "押运员",
          keyName: "escort",
          err: "请选择押运员",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        {
          label: "挂车号",
          keyName: "trailer_id",
          err: "请选择挂车号",
          type: "select",
          options: [],
          className: "instyle",
          clearable: true,
        },
        {
          label: "载货重量（吨）",
          keyName: "ton",
          err: "请填写载货重量",
          type: "number",
          className: "instyle",
        },
        {
          label: "车种",
          keyName: "vtype",
          type: "select",
          options: [],
          className: "instyle",
        },
        {
          label: "预支款类型",
          keyName: "prepaid_type_id",
          type: "select",
          options: [],
          className: "instyle",
        },
        /*{
          label: "是否新车",
          keyName: "isnew",
          type: "select",
          options: [],
        },*/
        {
          label: "车辆购入时间",
          keyName: "buytime",
          err: "请选择车辆购入时间",
          type: "date",
          className: "instyle",
        },
        {
          label: "资产金额",
          keyName: "asset",
          err: "请填写资产金额",
          type: "number",
          className: "instyle",
        },
        {
          label: "摊销年限",
          keyName: "amortization",
          err: "请填写摊销年限",
          type: "number",
          className: "instyle",
        },
        // {
        //   label: "开户银行",
        //   keyName: "bank_name",
        //   err: "请填写开户银行",
        //   type: "text",
        //   className: "instyle",
        // },
        // {
        //   label: "银行账号",
        //   keyName: "bank_card_no",
        //   err: "请填写银行账号",
        //   type: "text",
        //   className: "instyle",
        // },
      ],
      drivers: [],
      escorts: [],
      trailer_list: [],
      cartype: [],
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'car',
      }
    },

    setFleet() {
      const { fleetid, fleetName } = this.$route.query;
      if (!fleetid) return
      this.form.fleet = fleetid;
      if (!fleetName) return
      this.formCtrl.map((v) => {
        if (v.keyName == "fleet") {
          v.options = [{ label: fleetName, value: fleetid }];
        }
      });
    },
    getprepaidtype(value) {
      let url = `car/getprepaidtype`;
      const params = {
        car_type_id: value,
      }
      this.post(url, params, ({ msg, prepaid_type }) => {
        if (msg === 'success' && prepaid_type && prepaid_type.length) {
          this.formCtrl.map((c) => {
            if (c.keyName == "prepaid_type_id") {
              c.options = prepaid_type.map((v) => {
                return {
                  label: v.name,
                  value: v.id,
                };
              });
            }
          });
        } else {
          // this.$message({
          //   type: 'error',
          //   message: msg,
          // });
        }
      }, err => {
        console.log(err)
      })
    },
    onChange({ key, value }) {
      // console.log(key, value)
      if (key === 'vtype') {
        // console.log(key, value)
        this.form[key] = value
        this.form['prepaid_type_id'] = null
        this.cartype.map(v => {
          if (v.name === value) {
            this.getprepaidtype(v.id)
          }
        })
      } else if (key === 'bank_card_no') {
        const val = formatCardNumber(value)
        // console.log(key, value)
        // console.log(val)
        this.form[key] = val
      } else if (key === 'trailer') {
        this.trailer_list.map((v) => {
          if (v.trailer == value) {
            this.form['trailer_id'] = v.id;
            this.form['trailer'] = v.trailer
          }
        });
      } else if (key.includes("photo")) {
        this.form[key] = value.map((v) => {
          let result = v;
          if (v.response && v.response.photo) {
            result = {
              url: v.response.photo
            };
          }
          return result;
        });
      } else if (["driver"].includes(key)) {
        this.form[key] = value;
        this.drivers.map((v) => {
          if (v.name == value) {
            this.form["driverid"] = v.id;
          }
        });
      } else if (["escort"].includes(key)) {
        this.form[key] = value;
        this.escorts.map((v) => {
          if (v.name == value) {
            this.form["escortid"] = v.id;
          }
        });
      } else {
        this.form[key] = value;
      }
      // console.log({ ...this.form });
    },
    setDetail() {
      const keys = this.formCtrl.map((v) => {
        return v.keyName;
      });

      keys.map((key) => {
        const value = this.detail[key];
        if (["fleet"].includes(key)) {
          // this.form[key] = value + '';
        } else {
          this.form[key] = value;
        }
      });

      this.setPrepaidTypeOption()

      this.$forceUpdate();

      // console.log({ ...this.detail });
      // console.log({ ...this.form });
    },
    setPrepaidTypeOption() {
      const { vtype, prepaid_type_id } = this.detail
      if (vtype && prepaid_type_id && this.cartype && this.cartype.length) {
        this.cartype.map(v => {
          if (v.name === vtype) {
            this.getprepaidtype(v.id)
          }
        })
      }
    },
    setOptions({
      carstatus,
      cartype,
      isnew,
      driver,
      escort,
      fleet,
      trailer_list,
      // prepaid_type
    }) {
      // console.log(trailer_list)
      this.trailer_list = trailer_list;
      this.formCtrl.map((c) => {
        if (c.keyName == "trailer_id" && trailer_list && trailer_list.length) {
          c.options = trailer_list.map((v) => {
            return {
              label: v.trailer,
              value: v.id + '',
            };
          });
        }
        if (c.keyName == "fleet" && fleet && fleet.length) {
          c.options = fleet.map((v) => {
            return {
              label: v.nickname,
              value: v.id,
            };
          });
        }
        if (c.keyName == "carstatus" && carstatus && carstatus.length) {
          c.options = carstatus.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          if (!this.form.license) this.form.carstatus = carstatus[0].name;
        }
        if (c.keyName == "driver" && driver && driver.length) {
          c.options = driver.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          this.drivers = driver
        }
        if (c.keyName == "escort" && escort && escort.length) {
          c.options = escort.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });
          this.escorts = escort
        }
        if (c.keyName == "vtype" && cartype && cartype.length) {
          this.cartype = cartype
          c.options = cartype.map((v) => {
            return {
              label: v.name,
              value: v.name,
            };
          });

          this.setPrepaidTypeOption()
          // if (!this.form.license) this.form.vtype = cartype[0].name;
        }
        // if (c.keyName == "prepaid_type_id" && prepaid_type && prepaid_type.length) {
        //   c.options = prepaid_type.map((v) => {
        //     return {
        //       label: v.name,
        //       value: v.id,
        //     };
        //   });
        // }
        if (c.keyName == "isnew" && isnew) {
          for (const key in isnew) {
            if (Object.hasOwnProperty.call(isnew, key)) {
              const val = isnew[key];
              c.options.push({
                label: val,
                value: key,
              });
            }
          }
          this.form.isnew = "1";
        }
      });
      this.$forceUpdate();
      // console.log({ ...this.form })
    },
  },
  mounted() {
    const { fleetid, id } = this.$route.query;
    const params = {}
    if (fleetid) params['fleetid'] = fleetid
    if (id) params['car_id'] = id
    // console.log(params)
    this.getOptions(params);
    this.setFleet();
  },
}

export default minin